import cx from 'classnames'
import {
  Text,
  TextFontSizes,
  TextFontWeights,
  TextLineHeights,
} from '@cinch-labs/design-system'
import styles from './how-it-works.module.css'
import { Wrapper } from '@cinch-nx/shared-ui'
import { HowItWorksText } from '../../types/locales'
import HowItWorksStep from './how-it-works-step'
import FinanceOfferIcon from './assets/finance-offer.svg'
import FinanceApplyIcon from './assets/finance-apply.svg'
import FinanceDecisionIcon from './assets/finance-decision.svg'
import FinanceCalculatorIcon from './assets/finance-calculator.svg'
import Link from 'next/link'

interface HowItWorksProps {
  i18n: HowItWorksText
  className?: string
  children?: React.ReactNode
}

function renderLink(text: string, path: string, classNames?: string) {
  return (
    <Link href={path} passHref legacyBehavior>
      <a
        className={styles.linkText}
        target="_blank"
        rel="noreferrer noopener"
        href={path}
      >
        {text}
      </a>
    </Link>
  )
}

function HowItWorks({ i18n, className }: HowItWorksProps) {
  const [getAQuoteBeforeLink, getAQuoteAfterLink] =
    i18n.steps[0].splitText ?? []

  return (
    <article className={cx(styles.howItWorks, className)}>
      <Wrapper>
        <Text
          element="h2"
          fontSize={TextFontSizes['4xl']}
          fontWeight={TextFontWeights.bold}
          lineHeight={TextLineHeights.display}
          className={styles.howItWorksMainTitle}
        >
          {i18n.title}
        </Text>
        <Text fontSize={TextFontSizes.m} fontWeight={TextFontWeights.book}>
          {i18n.text}
        </Text>
        <ol className={styles.howItWorksSteps}>
          <HowItWorksStep i18n={i18n.steps[0]} Image={FinanceCalculatorIcon}>
            <Text fontSize={TextFontSizes.m} fontWeight={TextFontWeights.book}>
              <span data-testid="get-a-quote-before-text">
                {getAQuoteBeforeLink}
              </span>
              {renderLink('HP', '/car-finance/hire-purchase')} or{' '}
              {renderLink('PCP', '/car-finance/personal-contract-purchase')}
              <span data-testid="get-a-quote-after-text">
                {getAQuoteAfterLink}
              </span>
            </Text>
          </HowItWorksStep>
          <HowItWorksStep i18n={i18n.steps[1]} Image={FinanceApplyIcon} />
          <HowItWorksStep i18n={i18n.steps[2]} Image={FinanceDecisionIcon} />
          <HowItWorksStep i18n={i18n.steps[3]} Image={FinanceOfferIcon} />
        </ol>
      </Wrapper>
    </article>
  )
}

export default HowItWorks
